import React from "react";

const CtaTwo = () => {
  return (
    <section className="cta-two p-0 pt-4 cta-two--two" id="booking">
      <div className="container">
        <div className="cta-two__inner">

          {/* Background */}
          <div
            className="cta-two__bg"
            style={{
              backgroundImage: "url('/images/shapes/card-bg.png')",
            }}
          ></div>

          <div className="row">
            <div className="col-lg-6">
              <div className="cta-two__content">

                <div className="sec-title sec-title--two text-start">
                  <h6 className="sec-title__tagline">
                    Easy Vehicle Booking
                  </h6>

                  <h3 className="sec-title__title">
                    Book Tempo Travellers, Buses & Urbania With Aaradhya Travels
                  </h3>
                </div>

                <p className="cta-two__content__text">
                  Aaradhya Travels provides reliable and affordable travel
                  solutions for family trips, corporate events, weddings,
                  airport transfers, school excursions, and outstation tours.
                  Choose from our wide range of Tempo Travellers, Mini Buses,
                  Luxury Coaches, and Urbania vehicles for a comfortable,
                  safe, and hassle-free journey.
                </p>

                {/* <div className="cta-two__button">
                  <a href="/contact">
                    Get Free Quote
                  </a>

                  <a href="tel:+919876543210">
                    Book Now
                  </a>
                </div> */}

              </div>
            </div>
          </div>

          {/* Keep Existing Images */}
          <div className="cta-two__thumb">

            <div className="cta-two__thumb__item-one">
              <img
                src="/images/resources/card-man.png"
                alt="Booking Support"
              />
            </div>

            <div className="cta-two__thumb__item-two d-none">
              <img
                src="/images/resources/card-car.png"
                // src="/images/resources/card-car.png"
                alt="Aaradhya Travels"
              />
            </div>

            <div className="cta-two__thumb__item-element">
              <img
                src="/images/shapes/card-line-1-1.png"
                alt="Shape"
              />
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default CtaTwo;